import { useFeatureFlagObserver } from '@hooks/useFeatureFlagObserver';
import { FeatureFlagKeys } from '@lib/experiment';
import useStores from '@stores/useStores';

/**
 * Whether this user gets the inline Get started page, in place of the quick start page and the
 * checklist drawer: an organization admin, in a workspace with the flag on. Flagsmith buckets by
 * workspace (see `experiment.identify`). Everyone else keeps the quick start page and the drawer.
 * Callers read the user through MobX, so they must be observers.
 */
export const useIsInlineGetStartedEnabled = () => {
  const { userStore } = useStores();
  const isFlagOn = useFeatureFlagObserver(FeatureFlagKeys.enableInlineGetStarted);

  return isFlagOn && userStore.isOrgAdmin;
};
